import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Button,
  Popper,
  Paper,
  MenuItem,
  ClickAwayListener,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions
} from '@mui/material';

import MenuIcon from '@mui/icons-material/Menu';
import { Link, useNavigate } from 'react-router-dom';
import styles from './styles.module.css';
import NotificationsIcon from "@mui/icons-material/Notifications";
import SearchIcon from '@mui/icons-material/Search';
import tri_gases from "../../images/tri_gases.jpeg";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import LockResetIcon from '@mui/icons-material/LockReset';

import loginService from '../../services/login.Service';
import { useDispatch } from 'react-redux';
import userMasterService from '../../services/masters/userMaster.Service';
import CloseIcon from '@mui/icons-material/Close';

const Header = ({ toggleSidebar }) => {
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD?.result?.userInfo || null;
  const Role = userD?.result?.userInfo.role || null;
  const depot_short_code = userD?.result?.userInfo.depot_short_code || null;
  const depot_name = userD?.result?.userInfo.depot_name || null;
  const plant_name = userD?.result?.userInfo.plant_name || null;
  const user_name = userD?.result?.userInfo.full_name || null;
  const plant_short_code = userD?.result?.userInfo.plant_short_code || null;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [resetPasswordOpen, setResetPasswordOpen] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');


  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSettingsClick = () => {
    navigate('/Setting');
    handleClose();
  };

  const handleResetPasswordClick = () => {
    setResetPasswordOpen(true);
    handleClose();
  };

  const handleSearchClick = () => {
    console.log("Search button clicked");
  };

  const handleLogoutClick = async () => {
    try {
      const loginDetails = sessionStorage.getItem('loginUser');
      const userD = loginDetails ? JSON.parse(loginDetails) : null;

      const session_token = userD?.result?.authToken;
      const user_id = userD?.result?.userInfo?.user_id;

      const response = await loginService.logout({ user_id, session_token });

      if (response?.result?.success) {
        console.log("✅ Logout successful");
        sessionStorage.clear();
        navigate('/');
      } else {
        console.warn("⚠️ Logout failed:", response?.message || 'Unknown error');
      }
    } catch (error) {
      console.error("❌ Logout error:", error);
    }
  };

  const handleLogoClick = () => {
    navigate('/dashboard');
  };

const handlePasswordResetSubmit = async () => {
  if (!newPassword || !confirmPassword) {
    alert('Please fill in all fields');
    return;
  }

  if (newPassword !== confirmPassword) {
    alert('Passwords do not match');
    return;
  }

  const user_id = userD?.result?.userInfo?.user_id;

  try {
    const response = await userMasterService.getresetpasswordList({
      username: user_name,
      user_id: user_id,
      newPassword: newPassword,
    });

    // Check if response contains success message
    if (response?.message === "Password reset successfully.") {
      alert('Password successfully reset');
      setNewPassword('');
      setConfirmPassword('');
      setResetPasswordOpen(false); // Close the modal
    } else {
      alert(response?.message || 'Failed to reset password');
    }
  } catch (err) {
    console.error('Error resetting password:', err);
    alert('Error occurred while resetting password');
  }
};


  return (
    <>
      {/* <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: '#ffffff',
        }}
      > */}

      <AppBar
  position="fixed"
  elevation={0}
  sx={{
    zIndex: (theme) => theme.zIndex.drawer + 1,
    backgroundColor: '#1C3A5E',
  }}
>
        <Toolbar className={`${styles.header_Container}`}>
          <IconButton
            color="#000000"
            aria-label="open drawer"
            edge="start"
            onClick={toggleSidebar}
            sx={{ mr: 2, display: { lg: 'none' } }}
          >
            <MenuIcon />


          </IconButton>

          <Box
            className={`${styles.tri_gaseslogo}`}
            onClick={handleLogoClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && handleLogoClick()}
            sx={{ cursor: 'pointer' }}
          >
            <img src={tri_gases} alt='tri_gaseslogo' height={'100%'} width={'100%'} />
          </Box>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: 'auto',
              gap: 1,
            }}
          >
            <IconButton size="large" aria-label="notifications" color="inherit">
              <NotificationsIcon sx={{ color: "#000000" }} />
            </IconButton>

            <IconButton
              size="large"
              aria-label="quick search"
              color="inherit"
              component={Link}
              to="/reportnew/QuickSearch"
            >
              <SearchIcon sx={{ color: "#000000" }} />
            </IconButton>

            <Box className={`${styles.fName_Lname_container}`}>
              <Box>
                <Typography className={`${styles.fName_Lname_txt}`}>
                  {user_name}
                </Typography>
                <Typography className={`${styles.domain_name}`}>{Role}</Typography>
                <Box sx={{ display: 'flex' }}>
                  <Typography className={`${styles.domain_name}`} sx={{ marginRight: 1 }}>
                    {depot_short_code}
                  </Typography>
                  <Typography className={`${styles.domain_name}`} sx={{ marginRight: 1 }}>
                    {plant_short_code}
                  </Typography>
                  <Typography className={`${styles.domain_name}`} sx={{ marginRight: 1 }}>
                    {depot_name}
                  </Typography>
                  <Typography className={`${styles.domain_name}`}>
                    {plant_name}
                  </Typography>
                </Box>
              </Box>

              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={handleProfileClick}
                sx={{ padding: '5px !important' }}
              >
                <AccountCircleIcon sx={{ color: "#000000" }} />
              </IconButton>

              {/* Popper Menu */}
              <Popper
                open={open}
                anchorEl={anchorEl}
                placement="bottom-end"
                sx={{ zIndex: 1500, boxShadow: 6 }}
              >
                <ClickAwayListener onClickAway={handleClose}>
                  <Paper sx={{ minWidth: 130, backgroundColor: '#f8f8f8' }}>
                    <MenuItem onClick={handleSettingsClick}>
                      <Box className={`${styles.MenuItem_container}`}>
                        <SettingsIcon className={`${styles.Popper_icon}`} />
                        <Typography className={`${styles.Popper_txt}`}>Settings</Typography>
                      </Box>
                    </MenuItem>

                    <MenuItem onClick={handleResetPasswordClick}>
                      <Box className={`${styles.MenuItem_container}`}>
                        <LockResetIcon className={`${styles.Popper_icon}`} />
                        <Typography className={`${styles.Popper_txt}`}>Reset Password</Typography>
                      </Box>
                    </MenuItem>

                    <MenuItem onClick={handleLogoutClick}>
                      <Box className={`${styles.MenuItem_container}`}>
                        <LogoutIcon className={`${styles.Popper_icon}`} sx={{ color: 'red' }} />
                        <Typography className={`${styles.Popper_txt}`} sx={{ color: 'red' }}>Logout</Typography>
                      </Box>
                    </MenuItem>
                  </Paper>
                </ClickAwayListener>
              </Popper>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Reset Password Modal */}
      <Dialog open={resetPasswordOpen} onClose={() => setResetPasswordOpen(false)}>
        <DialogTitle sx={{ m: 0, p: 2 }}>
          Reset Password
          <IconButton
            aria-label="close"
            onClick={() => setResetPasswordOpen(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <TextField
            label="Username"
            fullWidth
            margin="dense"
            value={user_name}
            InputProps={{
              readOnly: true,
            }}
          />
          <TextField
            label="New Password"
            type="password"
            fullWidth
            margin="dense"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <TextField
            label="Confirm Password"
            type="password"
            fullWidth
            margin="dense"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </DialogContent>

        <DialogActions>
    <Button variant="contained" onClick={handlePasswordResetSubmit}>
  Submit
</Button>

        </DialogActions>
      </Dialog>
    </>
  );
};

export default Header;
